import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { BLOGS_API } from '../api/blog-api'
import { BlogPostId, BlogPostsInterface } from '../types/blog-posts-interface'

export const useBlogPostApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, BlogPostsInterface>({
    method: RequestMethodsEnum.post,
  })

  return {
    changePostStatus: (id: BlogPostId, update: 'activate' | 'deactivate') =>
      postFetcher(`${BLOGS_API}/posts/${id}/${update}`),
  }
}
